import { render, staticRenderFns } from "./import-invite-form.vue?vue&type=template&id=21caff66&scoped=true&"
import script from "./import-invite-form.vue?vue&type=script&lang=js&"
export * from "./import-invite-form.vue?vue&type=script&lang=js&"
import style0 from "./import-invite-form.vue?vue&type=style&index=0&id=21caff66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21caff66",
  null
  
)

export default component.exports